import { ReviewApiRoutes } from "../api";
export class ReviewApi {
    constructor(api) {
        this.api = api;
    }
    api;
    getProductReview(productId, page, count) {
        const url = ReviewApiRoutes.GetProductReviewList;
        const endpoint = url.replace(":id", `${productId}`);
        const params = new URLSearchParams();
        params.append("page", `${page}`);
        params.append("count", `${count}`);
        return this.api.get(endpoint, { params: params });
    }
    getReviews(page, count) {
        const params = new URLSearchParams();
        params.append("page", `${page}`);
        params.append("count", `${count}`);
        return this.api.get(ReviewApiRoutes.GetAllReviewsList, { params: params });
    }
}
